// extracted by mini-css-extract-plugin
export default {"epic":"#00a3ff","header":"B6","properties":"B7"};